<template>
  <div class="budget-amount-fields">
    <app-input
      :value="amount"
      :validate-immediate="false"
      name="Budget per period"
      label="Budget per period"
      type="number"
      step="0.01"
      placeholder="0.00"
      inputmode="decimal"
      :prepend="currencySymbol"
      rules="required"
      class="budget-amount-fields__amount"
      @input="onAmountInput"
      @blur="onAmountBlur"
      @change="onAmountBlur"
    />
    <app-input
      :value="period"
      :validate-immediate="false"
      name="Period"
      label="Period"
      type="dropdown"
      :options="periodOptions"
      undefined-label="Select period"
      rules="required"
      class="budget-amount-fields__period"
      @input="$emit('update:period', $event)"
    />
    <small v-if="periodHelper" class="budget-amount-fields__helper">{{ periodHelper }}</small>
  </div>
</template>

<script setup>
import AppInput from '@/components/AppInput.vue';
import { RECOGNITION_BUDGET_CADENCE_OPTIONS, toTwoDecimalsOrEmpty } from '@/pages/recognition/constants';

const props = defineProps({
  amount: {
    type: String,
    default: '',
  },
  period: {
    type: String,
    default: undefined,
  },
  currencySymbol: {
    type: String,
    required: true,
  },
  periodHelper: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:amount', 'update:period']);

const periodOptions = RECOGNITION_BUDGET_CADENCE_OPTIONS;

const onAmountInput = value => {
  const raw = String(value ?? '').replace(/[^0-9.]/g, '');
  const [intPart, decPartRaw] = raw.split('.');
  if (decPartRaw !== undefined) {
    emit('update:amount', `${intPart || '0'}.${decPartRaw.slice(0, 2)}`);
  } else {
    emit('update:amount', intPart || '');
  }
};

const onAmountBlur = () => {
  emit('update:amount', props.amount === '' ? '' : toTwoDecimalsOrEmpty(props.amount));
};
</script>

<style scoped lang="scss">
.budget-amount-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 0 1rem;

  &__amount,
  &__period {
    flex: 1 1 12rem;
    margin-bottom: 0.5rem;
  }

  &__helper {
    flex-basis: 100%;
    font-size: 0.8125rem;
    color: var(--palette-color-default-lighten-30);
  }
}
</style>
